import { FacilityRatingsService } from '../../api/services/FacilityRatingsService';
import { QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const facilityRatingsQueryKeys = new QueryKeyFactoryGenerator('facility-ratings').getDefault<
  typeof FacilityRatingsService.facilityRatingsList,
  string
>();
